<template>
  <div>
    <div>
      <div class=" bg-white border border-border rounded-md lg:mb-5 mb-4 lg:hidden" v-if="(state.opt_type == 'general' && state.enroll_option == 'individual')">
        <div class="p-4 flex items-start justify-start gap-4">
          <span
            class="w-[50px] h-[50px] bg-primaryLight border border-border flex rounded-md items-center justify-center shrink-0">
            <img src="@/assets/images/info.svg" alt="info">
          </span>
          <div>
            <p class="content" v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
              This application is to enroll as an individual, which means that you are not
              affiliated
              with
              a company that partners with us.
            </p>
            <p class="content" v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
              To inquire if your company is a partner with U.S. Legal, please email <a href="info@uslegalservices.net"
                class="text-blackPrimary">info@uslegalservices.net</a>
              or contact our Member
              Care
              Team at (800) 356-LAWS (5297).
            </p>
            <p class="content" v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
              Currently, individual enrollments are only accepted for the CDL Defender.
            </p>
          </div>
        </div>
      </div>
      <div class="bg-white border border-border rounded-md lg:mb-5 mb-4"
        v-if="state.opt_type == 'general' && state.enroll_option == 'individual'">
        <div class="flex w-full !m-0 p-4 gap-[8px] lg:items-center flex-col lg:flex-row items-start">
          <div class="flex xl:items-center gap-[8px] w-full items-baseline">
            <span class="number-badge">1</span>
            <h6 class="card-title !m-0">Do you have a valid Commercial Driver's License?</h6>
          </div>
          <div class="field-rep-block flex items-center gap-[16px] ms-[27px] lg:ms-0">
            <div class="field-radio-block">
              <label class="radio radio-outline-primary field-radio !mb-0">
                <input type="radio" :checked="state.hasCDL === 'yes'"
                  @change="$emit('updateState', { key: 'hasCDL', value: 'yes' })" name="hasCDL"
                  value="yes" /><span>Yes</span><span class="checkmark"></span>
              </label>
            </div>
            <div class="field-radio-block">
              <label class="radio radio-outline-primary field-radio !mb-0">
                <input type="radio" name="hasCDL" @change="$emit('updateState', { key: 'hasCDL', value: 'no' })"
                  value="no" /><span>No</span><span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="state.hasCDL === 'no'" class="bg-white border border-border rounded-md lg:mb-5 mb-4">
        <div class="text-center p-4 md:w-[400px] w-auto mx-auto">
          <span
            class="w-[60px] h-[60px] rounded-full flex items-center justify-center border bg-[#fff2f2] border-border mx-auto mb-4">
            <img src="@/assets/images/warning-info.svg" alt="info" />
          </span>
          <h6 class="font-bold text-blackPrimary text-lg">We're Sorry</h6>
          <p class="content !m-0">{{ state.eligibilityMessage }}</p>
           <br>
          <h6 class="font-bold text-blackPrimary text-lg" v-if="state.opt_type == 'general'">Coming Soon</h6>
          <p class="content !m-0" v-if="state.opt_type == 'general'">We will soon be accepting individual enrollments for our Family and Identity Defender plans! Please check back at a later date. </p>        </div>
      </div>
    </div>
    <div class="bg-white border border-border rounded-md lg:mb-5 mb-4"
      v-if="(state.enroll_option == 'affilliated' && state.opt_type == 'general' || state.opt_type == 'SEIU721')">
      <div class="flex w-full border-b border-border !m-0 p-4 gap-[8px] items-center">
        <span class="number-badge">1</span>
        <h6 class="card-title !m-0">Union Member Information</h6>
      </div>
      <div class="p-4">
        <div class="form-group mb-4 flex items-center justify-start gap-[16px]">
          <label class="font-normal text-mute text-sm mb-0 inline-block">
            Are you a SEIU721 Union Member?<span class="text-error">*</span>
          </label>
          <div class="flex items-center gap-[20px]">
            <div class="field-radio-block">
              <label class="radio radio-outline-primary field-radio !mb-0">
                <input type="radio" :checked="state.isSEIU === 'yes'"
                  @change="$emit('updateState', { key: 'isSEIU', value: 'yes' })" name="isSEIU"
                  value="yes" /><span>Yes</span><span class="checkmark"></span>
              </label>
            </div>
            <div class="field-radio-block">
              <label class="radio radio-outline-primary field-radio !mb-0">
                <input type="radio" name="isSEIU" @change="$emit('updateState', { key: 'isSEIU', value: 'no' })"
                  value="no" /><span>No</span><span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div v-if="state.isSEIU === 'no'" class="bg-white border border-border rounded-md lg:mb-5 mb-4">
          <div class="text-center p-4 md:w-[400px] w-auto mx-auto">
            <span
              class="w-[60px] h-[60px] rounded-full flex items-center justify-center border bg-[#fff2f2] border-border mx-auto mb-4">
              <img src="@/assets/images/warning-info.svg" alt="info" />
            </span>
            <h6 class="font-bold text-blackPrimary text-lg">We're Sorry</h6>
            <p class="content !m-0">
              To confirm Union Membership or to become a Member of the Union, please contact a SEIU721 Membership
              Analyst at membership@SEIU721.org or call (213) 251-3757. You may also click the following link to become
              a member or verify membership <u class="text-blue-500"><a
                  href="https://www.seiu721.org/create-account.php"
                  target="_blank">https://www.seiu721.org/create-account.php</a></u>
            </p>
          </div>
        </div>
        <!-- <div class="form-group mb-4" v-if="state.isSEIU=='yes'">
        <label class="font-normal text-mute text-sm mb-2 inline-block">
            Do you wish to enroll in the Family Defender plan?<span class="text-error">*</span>
          </label>
          <div class="field-radio-block">
            <label class="radio radio-outline-primary field-radio !mb-0">
              <input type="radio" :checked="state.isFAM === 'yes'"
                @change="$emit('updateState', { key: 'isFAM', value: 'yes' })" name="isFAM"
                value="yes" /><span>Yes</span><span class="checkmark"></span>
            </label>
          </div>
          <div class="field-radio-block">
            <label class="radio radio-outline-primary field-radio !mb-0">
              <input type="radio" name="isFAM" @change="$emit('updateState', { key: 'isFAM', value: 'no' })"
                value="no" /><span>No</span><span class="checkmark"></span>
            </label>
          </div>
        </div>
        <div v-if="state.isFAM === 'no'" class="bg-white border border-border rounded-md lg:mb-5 mb-4">
      <div class="text-center p-4 md:w-[400px] w-auto mx-auto">
        <span
          class="w-[60px] h-[60px] rounded-full flex items-center justify-center border bg-[#fff2f2] border-border mx-auto mb-4">
          <img src="@/assets/images/warning-info.svg" alt="info" />
        </span>
        <h6 class="font-bold text-blackPrimary text-lg">We're Sorry</h6>
        <p class="content !m-0">
          you decided not to enroll in the Family Defender plan. If you change your mind and decide to join click here <u class="text-blue-500"><a href="https://www.uslegalservices.net/companies/seiu721" target="blank">https://www.uslegalservices.net/companies/seiu721</a></u>.

        </p>
      </div>
    </div> -->
        <div class="form-group" v-if="state.isSEIU == 'yes' && state.isFAM == 'yes'">
          <label class="font-normal text-mute text-sm mb-2 inline-block">
            Select Company<span class="text-error">*</span>
          </label>
          <select id="company" name="company" v-model="selectedCompany" @change="updateSelectedCompany"
            class="form-mask">
            <option v-for="company in state.companies" :key="company.id" :value="company">
              {{ company.company_name }}
            </option>
          </select>
          <small class="mt-[8px] block text-mute text-xs font-normal">
            If you do not see your employer in this drop-down list, please contact a SEIU721 Membership Analyst at
            membership@SEIU721.org or call (213) 251-3757 to confirm if you are able to enroll.
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    state: Object,
  },
  data() {
    return {
      selectedCompany: null, // Local variable for v-model
    };
  },
  methods: {
    updateSelectedCompany() {
      this.$emit('updateState', { key: 'company', value: this.selectedCompany });
      this.$emit('updateState', { key: 'company_number', value: this.selectedCompany.company });
    }
  }
};
</script>

<style scoped>
/* Add any necessary styles here */
.info-box {
  /* Styles for the additional info box */
}

.info-message {
  /* Styles for the message shown when 'No' is selected */
}
</style>